const HeaderActionGroup: React.FC = ({ children }) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.5rem 1rem',
        flexWrap: 'wrap',
      }}
    >
      {children}
    </div>
  )
}

export default HeaderActionGroup
